// 关于我们页面静态数据

// 关于我们主页 - 顶部轮播图数据
export const aboutTopCarouselData = [
  {
    src: require('@/assets/img/about/introTopImg.jpg'),
    alt: '关于我们'
  }
]

// 走进瑞谦 - 团建活动轮播数据
export const intoRQSwiperData = {
  title: '团建活动',
  category: '团建活动',
  description: '丰富多彩的团建活动，拉进每一个瑞谦人的心',
  images: [
    {
      id: "1",
      url: require('@/assets/img/about/into/env_1.jpg'),
      alt: '现代化办公环境 - 舒适宽敞的办公空间'
    },
    {
      id: "2",
      url: require('@/assets/img/about/into/env_2.jpg'),
      alt: '员工休闲区 - 放松身心的休闲空间'
    },
    {
      id: "3",
      url: require('@/assets/img/about/into/env_3.jpg'),
      alt: '智能会议室 - 配备现代化会议设施'
    },
    {
      id: "4",
      url: require('@/assets/img/about/into/env_4.jpg'),
      alt: '开放式工作区 - 促进团队协作的空间设计'
    },
    {
      id: "5",
      url: require('@/assets/img/about/into/env_5.jpg'),
      alt: '温馨茶水间 - 提供多样饮品和零食'
    }
  ]
}

// 走进瑞谦 - 福利待遇图标数据
export const intoRQWelfareIcons = [
  {
    id: "1",
    imgUrl: require('@/assets/img/about/into/weal_1.jpg'),
    alt: "五险一金",
    explain: "别人有的，\n 你也必须安排上"
  },
  {
    id: "2",
    imgUrl: require('@/assets/img/about/into/weal_2.jpg'),
    alt: "带薪年假",
    explain: "入瑞谦满一年 \n 即可享有带薪年假"
  },
  {
    id: "3",
    imgUrl: require('@/assets/img/about/into/weal_3.jpg'),
    alt: "每月餐补",
    explain: "吃货津贴月月补 \n 随心吃、随心用"
  },
  {
    id: "4",
    imgUrl: require('@/assets/img/about/into/weal_4.jpg'),
    alt: "花样零食",
    explain: "工作之余放松片刻 \n 花样零食总在身边"
  },
  {
    id: "5",
    imgUrl: require('@/assets/img/about/into/weal_5.jpg'),
    alt: "花式团建",
    explain: "各种惊喜 \n 各种团建"
  },
  {
    id: "6",
    imgUrl: require('@/assets/img/about/into/weal_6.jpg'),
    alt: "节日福利",
    explain: "每一个特殊的日子 \n 都有惊喜"
  }
]

// 走进瑞谦 - 3D轮播图数据（工作环境）
export const intoRQCarouselItems = [
  {
    id: "1",
    imageSrc: require('@/assets/img/about/into/env_1.jpg'),
    alt: '前台区域',
    title: '明亮前台，超大独立空间',
    description: '明亮前台，超大独立空间'
  },
  {
    id: "2",
    imageSrc: require('@/assets/img/about/into/env_2.jpg'),
    alt: '办公区域',
    title: '开放式办公环境，自由现代',
    description: '开放式办公环境，自由现代'
  },
  {
    id: "3",
    imageSrc: require('@/assets/img/about/into/env_3.jpg'),
    alt: '荣誉墙',
    title: '满载荣誉，属于瑞谦人的骄傲',
    description: '满载荣誉，属于瑞谦人的骄傲'
  },
  {
    id: "4",
    imageSrc: require('@/assets/img/about/into/env_4.jpg'),
    alt: '休息区',
    title: '静音舱，寻找一段静谧时光',
    description: '静音舱，寻找一段静谧时光'
  },
  {
    id: "5",
    imageSrc: require('@/assets/img/about/into/env_5.jpg'),
    alt: '会议室',
    title: '宽阔会议室，萌发无限创意',
    description: '宽阔会议室，萌发无限创意'
  },
  {
    id: "6",
    imageSrc: require('@/assets/img/about/into/env_6.jpg'),
    alt: '展厅区',
    title: '展厅前台，坐拥无敌视野',
    description: '展厅前台，坐拥无敌视野'
  },
  {
    id: "7",
    imageSrc: require('@/assets/img/about/into/env_7.jpg'),
    alt: '休息区',
    title: '户外休闲，放松身心',
    description: '户外休闲，放松身心'
  },
  {
    id: "8",
    imageSrc: require('@/assets/img/about/into/env_8.jpg'),
    alt: '培训区域',
    title: '员工风采，记录每一个精彩时刻',
    description: '员工风采，记录每一个精彩时刻'
  },
  {
    id: "9",
    imageSrc: require('@/assets/img/about/into/env_9.jpg'),
    alt: '公司大门',
    title: '别致大门，开启一天的美好',
    description: '别致大门，开启一天的美好'
  },
  {
    id: "10",
    imageSrc: require('@/assets/img/about/into/env_10.jpg'),
    alt: '茶水间',
    title: '员工餐厅，享受恣意生活',
    description: '员工餐厅，享受恣意生活'
  }
]

